import * as THREE from 'three'

import Experience from '.'

export default class Light {
  private experience: Experience

  public directionalLight!: THREE.DirectionalLight
  public ambientLight!: THREE.AmbientLight

  constructor() {
    this.experience = new Experience()

    this.setInstance()
  }

  private setInstance() {
    this.directionalLight = new THREE.DirectionalLight('yellow', 0.4)
    this.ambientLight = new THREE.AmbientLight('white', 0.55)

    this.experience.scene.add(this.directionalLight, this.ambientLight)
  }
}
